var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"ma-2"},[_c('v-card-title',[_vm._v("新增首頁人氣兌換")]),_c('v-card-text',[_c('v-divider'),_c('item-form',{attrs:{"loading":_vm.loading},on:{"submit":_vm.submit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }